import { render, staticRenderFns } from "./IbAvatarUploader.vue?vue&type=template&id=90fe401a&scoped=true"
import script from "./IbAvatarUploader.vue?vue&type=script&lang=js"
export * from "./IbAvatarUploader.vue?vue&type=script&lang=js"
import style0 from "./IbAvatarUploader.vue?vue&type=style&index=0&id=90fe401a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fe401a",
  null
  
)

export default component.exports